import React from 'react';
import DwriSystemHeader from './sections/DwriSystemHeader';
import DwriManagementInfo from './sections/DwriManagementInfo';
import DwriAnnualUseSection from './sections/DwriAnnualUseSection';
import DwriPeakDaySection from './sections/DwriPeakDaySection';
import DwriPeakMonthSection from './sections/DwriPeakMonthSection';
import DwriSourceDataSection from './sections/DwriSourceDataSection';
import { useWaterSystemSearchModal } from '../../../reuseableComponents/WaterSystemSearchModalContext';
import '../dwri.css';

const DwriDataTab = ({ systemName, systemInfo, systemAnnualUse, waterUseSources, peakDayData, peakMonthData, loading, errors, selectedSources }) => {
    const { selectedWaterSystem } = useWaterSystemSearchModal();

    if (!loading.info && !systemName) {
        return (
            <p className="text-danger">
                <strong>A system with the ID of {selectedWaterSystem?.alternateNum} returned no DWRi data.</strong>
            </p>
        );
    }

    return (
        <div className="utah-design-system">
            <DwriSystemHeader
                systemName={systemName}
                loading={loading.info}
            />
            <DwriManagementInfo
                systemInfo={systemInfo}
                loading={loading.info}
                error={errors.info}
            />
            <br />
            <DwriAnnualUseSection
                waterUses={systemAnnualUse}
                loading={loading.annualUse}
                error={errors.annualUse}
            />
            <DwriPeakDaySection
                peakDayData={peakDayData}
                loading={loading.peak}
                error={errors.peak}
            />
            <DwriPeakMonthSection
                peakMonthData={peakMonthData}
                loading={loading.peak}
                error={errors.peak}
            />
            <DwriSourceDataSection
                sourceRecords={waterUseSources}
                selectedSources={selectedSources}
                loading={loading.annualUse}
                error={errors.annualUse}
            />
        </div>
    );
};

export default DwriDataTab;
